import { Module } from 'vuex'
import { RootState } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { usePremiumHttp } from '@/core/api/premium'
import { PremiumTrial, PremiumTrialPayload } from '@/core/models/premium-trial'

export type LifetimeUserCollection = {
    data: Array<PremiumTrial>,
    meta?: MetaPayload,
}

const state: LifetimeUserCollection = {
    data: [],
    meta: <any>{},
}

export const premiumLifetimeCollection: Module<LifetimeUserCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: LifetimeUserCollection, payload: any) => {
            state.data = []
            ;(payload.data || []).forEach((item: PremiumTrialPayload) => {
                state.data.push(new PremiumTrial(item))
            })
            state.meta = payload.meta
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                usePremiumHttp()
                    .getLifetimeUsers(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: LifetimeUserCollection): LifetimeUserCollection => {
            return state
        },
    },
}
